const subscriptions = [
  {
    title: "Free",
    price: "0",
    description: "Create script and use screenwriting anytime with 3 projects",
    background: '#dba102',  // '#F1C40F' with 70% opacity
    isActive: true,
    features: [
      { name: "Alex AI 2 Prompts only", available: true },
      { name: "3 Documents", available: true },
      { name: "Film, TV, Treatment", available: true },
      { name: "Unlimited Disk Space", available: true },
      { name: "Auto Industry Format", available: true },
      { name: "Character Breakdown", available: true },
      { name: "Categories and Elements", available: true },
      { name: "Scene Breakdown", available: true },
      { name: "Scene Cards", available: true },
      { name: "Notes and Revision", available: true },
      { name: "Collaborate and Share", available: true },
      { name: "Block Actor Dialogue", available: true },
      { name: "Upload Final Draft Script", available: true },
      { name: "Upload and Download Script (PDF) Admin Only", available: true },
    ],
  },
  {
    title: "Freemium",
    price: "0",
    description: "Create script and use screenwriting anytime with 3 projects",
    background: 'rgba(255, 163, 0, 1)',  // '#ffa300' with 70% opacity
    isActive: true,
    features: [
      { name: "3 Documents", available: true },
      { name: "Film, TV, Treatment", available: true },
      { name: "Unlimited Disk Space", available: true },
      { name: "Auto Industry Format", available: true },
      { name: "Character Breakdown", available: false },
      { name: "Categories and Elements", available: false },
      { name: "Scene Breakdown", available: false },
      { name: "Scene Cards", available: false },
      { name: "Notes and Revision", available: false },
      { name: "Collaborate and Share", available: false },
      { name: "Block Actor Dialogue", available: false },
      { name: "Upload Final Draft Script", available: false },
      { name: "Upload and Download Script (PDF) Admin Only", available: true },
    ],
  },
  {
    title: "Essential",
    price: "7.48",
    description: "Create your script with unlimited documents, anytime and anywhere",
    background: 'rgba(2, 153, 253, 1)',  // '#0299fd' with 70% opacity
    features: [
      { name: "Unlimited Documents", available: true },
      { name: "Film, TV, Treatment", available: true },
      { name: "Unlimited Disk Space", available: true },
      { name: "Auto Industry Format", available: true },
      { name: "Character Breakdown", available: true },
      { name: "Categories and Elements", available: true },
      { name: "Scene Breakdown", available: true },
      { name: "Scene Cards", available: false },
      { name: "Notes and Revision", available: false },
      { name: "Collaborate and Share", available: false },
      { name: "Block Actor Dialogue", available: true },
      { name: "Upload Final Draft Script", available: false },
      { name: "Upload and Download Script (PDF) Admin Only", available: true },
    ],
  },
  {
    title: "Professional",
    price: "9.98",
    description: "Create your script and collaborate with your team in real-time",
    background: 'rgba(26, 73, 186, 1)',  // '#1a49ba' with 70% opacity
    features: [
      { name: "Unlimited Documents", available: true },
      { name: "Film, TV, Treatment", available: true },
      { name: "Unlimited Disk Space", available: true },
      { name: "Auto Industry Format", available: true },
      { name: "Character Breakdown", available: true },
      { name: "Categories and Elements", available: true },
      { name: "Scene Breakdown", available: true },
      { name: "Scene Cards", available: true },
      { name: "Notes and Revision", available: true },
      { name: "Collaborate and Share", available: true },
      { name: "Block Actor Dialogue", available: true },
      { name: "Upload Final Draft Script", available: true },
      { name: "Upload and Download Script (PDF) Admin Only", available: true },
    ],
  },
];

export default subscriptions;
